import {useOpenedStateManager} from '@aboutyou/opened-state-manager';

const COUPON_STICKY_BAR_OPEN_STATE_MANAGER_KEY = 'coupon-sticky-bar';
const COUPON_STICKY_BAR_IN_MINI_ADP_DIALOG_KEY =
  'coupon-sticky-bar-in-mini-adp-dialog';

export const useCouponStickyBarOpenStateManager = (
  isInMiniADPDialog = false,
) => {
  const openedStateManagerKey = isInMiniADPDialog
    ? COUPON_STICKY_BAR_IN_MINI_ADP_DIALOG_KEY
    : COUPON_STICKY_BAR_OPEN_STATE_MANAGER_KEY;

  const {isOpen, open} = useOpenedStateManager(openedStateManagerKey);

  return {isOpen, open, openedStateManagerKey};
};
